export default __webpack_public_path__ + "static/media/SapatoKahshStoreWeb.c63a1e1b.png";